import settingsStateSlice from './slice'

// eslint-disable-next-line import/prefer-default-export
export const settingsStateActions = settingsStateSlice.actions
